module.exports = __webpack_public_path__ + "static/coaches.ee27d6b2.png";